import { stringField, optionField } from 'common/utils/form/fieldTypes';

export default {
  default: stringField(),
  organizations: optionField()
};
